import type { V4ApiResponse } from '@api/types';
import type { CarrierLookup } from '@store/carriers/carrierLookup/types';

export type statusTypes = {
  Customer: 'Customer';
  Dead: 'Dead';
  Duplicate: 'Duplicate';
  'Collection Hold': 'Collection Hold';
  Dormant: 'Dormant';
  Pending: 'Pending';
  Inactive: 'Inactive';
  'Credit Hold': 'Credit Hold';
};

export type ApprovedCarrier = {
  id: number;
  name: string;
  status: keyof statusTypes;
  mc: string;
  dot: string;
  mode: string;
  city: string;
  state: string;
  contact: string;
  phone: string;
  contactVerificationStatus: number;
  rating: number;
  loadsCompleted: number;
  fallouts: number;
  equipment: string[];
  modifiedDate: string;
  blacklisted: boolean;
  conditionalActionPlanReceived: boolean;
  hazmat: boolean;
  smartway: boolean;
  transfloEnabled: boolean;
  expiredInsurance: boolean;
  isDuplicate?: boolean;
};

export type ApprovedCarriersApiResponse = {
  totalCount: number;
  data: ApprovedCarrier[];
};

export type ApprovedCarrierQueryParams = {
  $top: number;
  $skip: number;
  $orderby: string;
  $format: string;
  $count: boolean;
  $filter?: string;
};

export type LookUpDataResponse = CarrierLookup;

export type LookUpApiResponse = V4ApiResponse<LookUpDataResponse>;

export type CarrierEditHistoryItem = {
  action: string;
  field: string;
  description: string;
  timeStamp: string;
  oldValue: null;
  newValue: string;
  editedBy: string;
  historyType: string;
};

export enum DataSource {
  Internal = 0,
  ATG = 1,
  Highway = 2,
  DAT = 3,
}

export type PreferredLaneT = {
  id: number;
  carrierId: number;
  originLane: string;
  originCity: string;
  originState: string;
  originPostal: string;
  originCountry: string;
  originLatitude: number;
  originLongitude: number;
  destinationLane: string;
  destinationCity: string;
  destinationState: string;
  destinationPostal: string;
  destinationCountry: string;
  destinationLatitude: number;
  destinationLongitude: number;
  equipmentCategory: number;
  canDelete: boolean;
  source: DataSource;
  createdDate: string;
  createdBy: number;
  modifiedDate: string;
  modifiedBy: number;
  historyContext: string;
  truckCreationSucceeded?: boolean;
};

export type EquipmentT = {
  equipmentId: number;
  equipmentName: string;
};

export type EquipmentCategoryT = {
  categoryId: number;
  categoryName: string;
  equipment: EquipmentT[];
};
